"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var mobx_react_1 = require("mobx-react");
var react_lazyload_1 = require("react-lazyload");
var tyrande_1 = require("tyrande");
var WithEZSpm_1 = require("../../../components/WithEZSpm");
var ProductCard_1 = require("./ProductCard");
var styles = require("./index.scss");
var ProductSession_1 = require("./ProductSession");
var store_1 = require("./store");
var url_1 = require("../../../utils/url");
var ssrcontext_1 = require("../../../ssrcontext");
var array_1 = require("../../../utils/array");
var FlashProducts = (function (_super) {
    __extends(FlashProducts, _super);
    function FlashProducts(props) {
        var _this = _super.call(this, props) || this;
        _this.onTagsChange = function (_session, index, fixed) {
            _this.flashStore.changeSelectedIndex(index);
            if (fixed) {
                window.scrollTo(0, _this.contentRef.offsetTop - _this.props.stickToTop);
            }
        };
        _this.onChangeSessionPosition = function (key) {
            var _a = _this.flashStore, currentPosition = _a.currentPosition, flashModules = _a.flashModules;
            if (currentPosition > 0 && key === "previous") {
                _this.flashStore.changePosition(currentPosition - 1);
            }
            if (key === "next" && currentPosition <= flashModules.length - 4) {
                _this.flashStore.changePosition(currentPosition + 1);
            }
        };
        _this.state = {};
        _this.flashStore = new store_1.FlashStore(props.moduleId, props.multiTab, props.isActView, props.flashModules);
        return _this;
    }
    FlashProducts.prototype.genTSpmLinkByUrl = function (url, order, name, productOrder) {
        var _a = this.props.spm, site = _a.site, pageId = _a.pageId, activityId = _a.activityId, componentType = _a.componentType, index = _a.index;
        var withTag = componentType === tyrande_1.ComponentType.FlashProductWithTag;
        var params = {
            site: site,
            activityId: activityId,
            pageId: pageId,
            channel: index,
            channelContent: {
                type: componentType,
                order: withTag ? order : "00",
                content: withTag ? name : "00",
                productOrder: productOrder
            }
        };
        return tyrande_1.genSpmLink(__assign(__assign({}, params), { url: url }), false);
    };
    FlashProducts.prototype.linkTo = function (url) {
        tyrande_1.sendEzspmByLink(url, false);
    };
    FlashProducts.prototype.render = function () {
        var _this = this;
        var _a = this.props, stickToTop = _a.stickToTop, columnSize = _a.columnSize, multiTab = _a.multiTab;
        var _b = this.flashStore, flashModules = _b.flashModules, flashProductList = _b.flashProductList, currentPosition = _b.currentPosition, activeIndex = _b.activeIndex;
        var productOrder = 0;
        var hasValidData = array_1.isNotBlankArray(flashProductList);
        if (!hasValidData) {
            return null;
        }
        return (React.createElement("div", { className: styles.products, ref: function (e) { return (_this.contentRef = e); } },
            flashModules.length > 0 && multiTab && (React.createElement(ProductSession_1.default, { sessions: flashModules, stickToTop: stickToTop, currentPosition: currentPosition, selectedIndex: activeIndex, onChange: this.onTagsChange, onChangePosition: this.onChangeSessionPosition })),
            React.createElement("div", { className: styles.productContent }, flashProductList.reduce(function (memo, item, index) {
                return memo.concat(item.products.map(function (product, idx) {
                    productOrder++;
                    var ezSpmUrl = _this.genTSpmLinkByUrl(url_1.getLocalProductUrl(product.gpid) || product.url, Number(activeIndex) + 1, item.activeId, multiTab ? idx + 1 : productOrder);
                    return (React.createElement(ProductCard_1.default, { key: index + "" + idx, product: product, productUrl: ezSpmUrl, imageOnly: item.imgOnly, flashState: item.state, multiTab: multiTab, flashName: item.flashName, onClick: function () { return _this.linkTo(product.url); }, type: columnSize === 5 ? "small" : "normal" }));
                }));
            }, []))));
    };
    FlashProducts.defaultProps = {
        columnSize: 4,
        stickToTop: 0
    };
    FlashProducts = __decorate([
        mobx_react_1.observer
    ], FlashProducts);
    return FlashProducts;
}(React.Component));
exports.default = WithEZSpm_1.default(function FlashProductWrapper(props) {
    return (React.createElement("div", { id: props.id }, ssrcontext_1.runInServer() && props.positionIndex < 4 ? (React.createElement(FlashProducts, __assign({}, props))) : (React.createElement(react_lazyload_1.default, { offset: 100, height: ssrcontext_1.runInServer() ? 100 : window.innerHeight },
        React.createElement(FlashProducts, __assign({}, props))))));
});
